// extracted by mini-css-extract-plugin
module.exports = {"layout":"screen_layout__2pNiW","main":"screen_main__2i1ed"};